import styled from 'styled-components';
import { Segment } from '@playbookux/playbook-web-core';

export const ConnectButtonContainer = styled.div`
  margin-top: 1rem;

  #pathfix-oauth-extension{
    border-radius: 1px;
    border: 1px solid #EFEFEF;
    box-shadow: none;
  }

  &&& .pinc-oauth-ui.list-panel{
    margin-bottom: 0;
  }
  
  .pinc-ui * {
    font-family: 'Roboto' !important;
  }

  &&& .d-flex.py-2.flex-grow-1.p-name-group {
    display: flex !important;
    width: 100% !important;
  }

  &&& .flex-grow-1.p-name-group-text {
    display: flex !important;
    justify-content: space-between;
  }

  &&& .c-item-label.d-flex.justify-content-between{
    width: 100%;
    //target 2nd div element
    & > div:nth-child(2){
      display: flex;
      align-items: center;
    }
  }

  &&& .icon-md.p-1.rounded.bg-white.c-item-icon{
    width: 4em;
    height: 4em;
  }

  &&& .provider-li{
    margin-left: 14px;
    font-size: 14px;
  }

  &&& .provider-description-ul{
    flex-grow: 1;
    align-items: center;
    display: flex;
    
  }


`;

export const ServiceContainer = styled(Segment)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &&& {
    margin-top: 1rem;
  }
`;

export const HiddenDiv = styled.div`
  display: none !important;
`;
